/* eslint-disable no-unused-vars */
import { useEffect } from 'react';

interface Window {
  dataLayer: any[];
  gtag: (...args: any[]) => void;
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const useGA4 = () => {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }

    gtag('js', new Date());

    // Configure GA4
    gtag('config', 'G-EN92R4P8BL');
  }, []);
};
